/**
 * IMPORTANT: Do not change the values in this file without updating them in zindex.less
 *
 * ISSUE #7308 (https://github.com/webflow/webflow/issues/7308) will remove the need for this synchronization
 *
 * NOTE: For new components, use ui/Layer, not these zIndex: https://github.com/webflow/webflow/blob/dev/docs/ui/overlay-system.md
 *
 */

export const zIndexMax = 2147483647;
export const zIndexBase = 10;
export const zIndexPagesMenuMaster: number = zIndexBase + 1;
export const zIndexToolsFluxLayer: number = zIndexPagesMenuMaster + 1;
export const zIndexToolsLayer: number = zIndexToolsFluxLayer + 1;
export const zIndexCanvasBar: number = zIndexToolsLayer + 1;
export const zIndexGrid = 1;
export const zIndexGogglesMargin = 1;
export const zIndexGogglesPadding: number = zIndexGogglesMargin + 1;
export const zIndexGogglesInside: number = zIndexGogglesPadding + 1;
export const zIndexGogglesNegative: number = zIndexGogglesInside + 1;
export const zIndexCanvasScrollbar: number = zIndexGogglesNegative + 1;
export const zIndexOutlineDynItem: number = zIndexCanvasScrollbar + 1;
export const zIndexOutlineHovered: number = zIndexOutlineDynItem + 1;
export const zIndexOutlineSelected: number = zIndexOutlineHovered + 1;
export const zIndexOutlineParent: number = zIndexOutlineSelected + 1;
export const zIndexOutlineDropParent: number = zIndexOutlineParent + 1;
export const zIndexOutlineInsert: number = zIndexOutlineDropParent + 1;
export const zIndexInsertGuide: number = zIndexOutlineInsert + 1;
export const zIndexGridControls: number = zIndexInsertGuide + 1;
export const zIndexHUD: number = zIndexGridControls + 1;
export const zIndexHudLabel: number = zIndexHUD + 1;
export const zIndexRTEToolbarsDesCan: number = zIndexHudLabel + 1;
export const zIndexMiniSettingsMask: number = zIndexRTEToolbarsDesCan + 1;
export const zIndexRightSidebarMask: number = zIndexToolsLayer + 1;
export const zIndexRightSidebar: number = zIndexRightSidebarMask + 1;
export const zIndexWorkspaceWarning: number = zIndexRightSidebar + 1;
export const zIndexKitBlocker: number = zIndexWorkspaceWarning + 1;
export const zIndexMiniSuggestions: number = zIndexKitBlocker + 1;
export const zIndexAutoCompleteResults: number = zIndexMiniSuggestions + 1;
export const zIndexPanelMask: number = zIndexAutoCompleteResults + 1;
export const zIndexButtonOverMask: number = zIndexPanelMask + 1;
export const zIndexPanelPop: number = zIndexButtonOverMask + 1;
export const zIndexPanel: number = zIndexPanelPop + 1;
export const zIndexPanelMaskDepth1: number = zIndexPanel + 1;
export const zIndexPanelDepth1: number = zIndexPanelMaskDepth1 + 1;
export const zIndexPanelMaskDepth2: number = zIndexPanelMaskDepth1 + 1;
export const zIndexPanelDepth2: number = zIndexPanelDepth1 + 1;
export const zIndexMiniSettings: number = zIndexPanelDepth2 + 1;
export const zIndexTopBar: number = zIndexMiniSettings + 1;
export const zIndexLeftSidebarPanels: number = zIndexTopBar + 1;
export const zIndexLeftSidebarPanelsKO: number = zIndexLeftSidebarPanels + 1;
export const zIndexLeftSidebar: number = zIndexLeftSidebarPanelsKO + 1;
export const zIndexPopover: number = zIndexLeftSidebar + 1;
export const zIndexPublishTargets: number = zIndexPopover + 1;
export const zIndexNewDomNodeClone: number = zIndexPublishTargets + 1;
export const zIndexFancySelectDropdown: number = zIndexNewDomNodeClone + 1;
export const zIndexCasper: number = zIndexFancySelectDropdown + 1;
export const zIndexUnitMenu: number = zIndexCasper + 1;
export const zIndexCssPreview: number = zIndexUnitMenu + 1;

export const zIndexModalMask = 10000;
export const zIndexModal: number = zIndexModalMask + 1;
export const zIndexNotifications: number = zIndexModal + 1;
export const zIndexPreloader: number = zIndexNotifications + 1;

// This is a special case, minus one, so that `Layer`-managed components will render under legacy (zIndexModalMask) ones
export const zIndexWindowOverlay = zIndexModalMask - 1;

export const zIndexTooltip = zIndexMax - 100;
export const zIndexFullPageMask: number = zIndexTooltip + 1;

/**
 * Values for the Spring Design System.
 *
 * @see packages/systems/spring
 */
export const zIndexSpringModal = 10000;

/**
 * Values for the Dashboard.
 */
export const zIndexToaster: number = zIndexSpringModal + 1;
